import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

const AnonMemoryLayout: React.FC = () => {
  useEffect(() => {
    // Remove sidebar and header layout classes for this anonymous page
    const originalClasses = document.body.className;
    document.body.classList.remove('sidebar-fixed', 'header-fixed', 'demo1');
    
    // Clean up on unmount - restore original classes
    return () => {
      document.body.className = originalClasses;
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col w-full">
      <Outlet />
    </div>
  );
};

export default AnonMemoryLayout;